import { logError } from "services/logging";
import * as ConversationEvents from "./conversation";
import * as ResponseEvents from "./response";
import * as SessionEvents from "./session";

// Partial list of events available in the Realtime API

// The server events this app names.
export type NamedServerEvent =
  | SessionEvents.ServerSessionEvent
  | ResponseEvents.ServerResponseEvent
  | ConversationEvents.ServerConversationEvent;

// The fallback arm widens this union's `type` to string, so anything that needs
// the literal types maps over NamedServerEvent instead.
export type RealtimeServerEvent = NamedServerEvent | { type: string };

export type RealtimeClientEvent =
  | SessionEvents.ClientSessionEvent
  | ConversationEvents.ClientConversationEvent
  | ResponseEvents.ResponseClientEvent
  | ClearInputAudioBufferEvent
  | ClearOutputAudioBufferEvent
  | { type: string }; // Fallback for untyped events;

export type ClearInputAudioBufferEvent = {
  type: "input_audio_buffer.clear";
};

export type ClearOutputAudioBufferEvent = {
  type: "output_audio_buffer.clear";
};

export type * from "./session";
export type * from "./response";
export * from "./conversation";

export type EventOfType<T extends RealtimeServerEvent["type"]> = Extract<
  RealtimeServerEvent,
  { type: T }
>;

export const parseServerEventData = (
  event: MessageEvent<string>
): RealtimeServerEvent => {
  try {
    return JSON.parse(event.data) as RealtimeServerEvent;
  } catch (error) {
    logError("Error parsing server event data:", { error, data: event.data });
    throw error;
  }
};
